import { useMemo } from 'react';

import { ContainerSection } from '@pflegia/ui/shared/container-section/ContainerSection';

import { renderJobTitlePageHtml } from './render-job-title-page-html';

const CONTENT_CLASS_NAME = [
  'text-sm text-blue-950 lg:text-base',
  '[&_h2]:mt-10 [&_h2]:mb-4 [&_h2]:text-2xl [&_h2]:font-medium lg:[&_h2]:text-3xl',
  '[&_h3]:mt-6 [&_h3]:mb-2 [&_h3]:text-lg [&_h3]:font-medium',
  '[&_p]:mb-4 [&_blockquote]:mb-4 [&_blockquote]:border-l-4 [&_blockquote]:pl-4',
  '[&_ul]:mb-4 [&_ul]:ml-6 [&_ul]:list-disc [&_ol]:mb-4 [&_ol]:ml-6 [&_ol]:list-decimal [&_li]:mb-1',
  '[&_a]:text-primary [&_a]:underline',
  '[&_table]:mb-6 [&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto [&_table]:border-collapse',
  '[&_td]:border [&_td]:border-gray-300 [&_td]:p-2 [&_th]:border [&_th]:border-gray-300 [&_th]:bg-gray-50 [&_th]:p-2 [&_th]:text-left',
].join(' ');

interface JobTitlePageRichContentProps {
  html: string;
}

export const JobTitlePageRichContent: React.FC<JobTitlePageRichContentProps> = ({ html }) => {
  const content = useMemo(() => renderJobTitlePageHtml(html), [html]);

  return (
    <ContainerSection className='mt-12 md:mt-20'>
      <div className={CONTENT_CLASS_NAME} data-testid='job-title-page-content'>
        {content}
      </div>
    </ContainerSection>
  );
};
